import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const supportedLanguages = ["en-US", "en-CA", "fr-CA"];

const isDev = process.env.NODE_ENV === "development";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend((language, namespace) => {
      return import(`./locales/${language}/${namespace}.json`);
    })
  )
  .init({
    fallbackLng: "en-US",
    defaultLocale: "en-US",
    supportedLngs: supportedLanguages,
    debug: isDev,
    interpolation: {
      escapeValue: false,
    },
	locales: supportedLanguages,
  });

i18n.on("languageChanged", (lng) => {
  if (!supportedLanguages.includes(lng)) {
    i18n.changeLanguage("en-US");
  }
});

export default i18n;
